export const translations = {
  EN: {
    nav: { markets: "Markets", regulation: "Regulation", italy: "Italy", services: "Services", heritage: "Heritage", contact: "Contact", portal: "Client Area" },
    hero: {
      badge: "CSSF Regulated · Firm N° P00000438",
      lines: ["Institutional", "precision in", "CFD trading."],
      lead: "ASTEO LUXEMBOURG S.A. — a European investment firm regulated in Luxembourg and Italy, executing multi-asset strategies from 120 Boulevard de la Pétrusse since 2014.",
      cta1: "Explore Markets",
      cta2: "Regulation Details",
      stats: [
        { value: "2014", label: "CSSF authorised" },
        { value: "Class 3", label: "IFR classification" },
        { value: "4", label: "Investment services" },
        { value: "LU · IT", label: "Regulated jurisdictions" },
      ],
    },
    marquee: ["Forex", "Indices", "Commodities", "Shares", "CSSF Regulated", "MiFID II", "Family Office", "Portfolio Management", "Investment Advice", "LEI 222100L7BX1XCBJHH958"],
    manifesto: {
      overline: "The Asteo Standard",
      title: "A brokerage built on four principles",
      chapters: [
        { num: "01", title: "Institutional Precision", body: "Every order — reception, transmission, execution — is handled with the discipline of an institutional desk. Authorised for order execution on behalf of clients since 20 October 2014." },
        { num: "02", title: "European Safeguards", body: "Supervised by the CSSF in Luxembourg and operating in Italy under EU passporting. IFR Class 3 classification, LEI-verified, MiFID II compliant. Your counterparty is a regulated S.A." },
        { num: "03", title: "Multi-Asset Execution", body: "CFDs across foreign exchange, global indices, commodities and shares — supported by authorised FX services connected to the provision of investment services." },
        { num: "04", title: "Family Office Heritage", body: "An authorised Family Office actively performing since 2014. Discretionary portfolio management and investment advice, delivered with Luxembourg private-banking rigour." },
      ],
    },
    markets: {
      overline: "Markets",
      title: "Trade the world's markets, one account",
      lead: "Contracts for difference across four asset classes, executed with institutional discipline. Availability and conditions provided on the trading platform.",
      tabs: { forex: "Forex", indices: "Indices", commodities: "Commodities", shares: "Shares" },
      colInstrument: "Instrument",
      colSession: "Trading session",
      colType: "Category",
      note: "Instruments shown are illustrative. CFDs are complex instruments — refer to the platform for live conditions.",
      data: {
        forex: [
          ["EUR / USD", "24h · Mon–Fri", "Major"],
          ["GBP / USD", "24h · Mon–Fri", "Major"],
          ["USD / JPY", "24h · Mon–Fri", "Major"],
          ["EUR / CHF", "24h · Mon–Fri", "Cross"],
          ["USD / CAD", "24h · Mon–Fri", "Major"],
        ],
        indices: [
          ["EU Stocks 50", "08:00–22:00 CET", "Europe"],
          ["Germany 40", "08:00–22:00 CET", "Europe"],
          ["US 500", "15:30–22:00 CET", "North America"],
          ["US Tech 100", "15:30–22:00 CET", "North America"],
          ["Japan 225", "01:00–07:00 CET", "Asia"],
        ],
        commodities: [
          ["Gold (XAU/USD)", "24h · Mon–Fri", "Precious metal"],
          ["Silver (XAG/USD)", "24h · Mon–Fri", "Precious metal"],
          ["Brent Crude Oil", "03:00–23:00 CET", "Energy"],
          ["WTI Crude Oil", "03:00–23:00 CET", "Energy"],
          ["Natural Gas", "03:00–23:00 CET", "Energy"],
        ],
        shares: [
          ["European blue chips", "09:00–17:30 CET", "Equity CFD"],
          ["US large caps", "15:30–22:00 CET", "Equity CFD"],
          ["Italian listed shares", "09:00–17:30 CET", "Equity CFD"],
          ["Luxembourg listed", "09:00–17:30 CET", "Equity CFD"],
          ["UK FTSE constituents", "09:00–17:30 CET", "Equity CFD"],
        ],
      },
    },
    regulation: {
      overline: "Regulation & Licensing",
      title: "Fully licensed. Fully transparent.",
      lead: "ASTEO LUXEMBOURG S.A. is an investment firm supervised by the Commission de Surveillance du Secteur Financier (CSSF), Luxembourg, and operates in Italy.",
      cardTitle: "CSSF Public Register Entry",
      fields: [
        ["Name", "ASTEO LUXEMBOURG S.A. (Active)"],
        ["Type", "Investment firm"],
        ["Firm N°", "P00000438"],
        ["Registered office", "120 Boulevard de la Pétrusse, L-2330 Luxembourg"],
        ["Validity date", "20/10/2014"],
        ["LEI code", "222100L7BX1XCBJHH958"],
        ["IFR classification", "Class 3 (SNI investment firm)"],
      ],
      servicesTitle: "Services & investment activities",
      auxTitle: "Auxiliary services",
      statusTitle: "Other status",
      colService: "Authorisation",
      colStart: "Start of validity",
      colEnd: "End of validity",
      ongoing: "Ongoing",
      services: [
        "1 — Reception and transmission of orders in relation to one or more financial instruments",
        "2 — Execution of orders on behalf of clients",
        "4 — Portfolio management",
        "5 — Investment advice",
      ],
      aux: [
        "4 — Foreign exchange services connected to the provision of investment services",
        "5 — Investment research and financial analysis or other forms of general recommendation",
      ],
      status: ["Family Office", "Authorised Family Office actively performing the activity Family Office"],
      history: "Name history: registered as ASTEO LUXEMBOURG S.A. since 19/09/2011.",
      verify: "Verify on the CSSF register",
    },
    italy: {
      overline: "Italy · CONSOB register",
      title: "Authorised to operate in Italy",
      lead: "Under the MiFID II freedom to provide services, ASTEO LUXEMBOURG S.A. is entered in the register of EU investment firms operating in Italy without a branch, maintained by CONSOB.",
      cardTitle: "Register entry — Italy",
      fields: [
        ["Investment firm", "ASTEO LUXEMBOURG S.A."],
        ["Registered office", "120 Boulevard de la Pétrusse"],
        ["City", "L-2330 Luxembourg"],
        ["State", "Luxembourg"],
        ["Register entry N°", "4129"],
      ],
      servicesTitle: "Services exercisable in Italy",
      services: [
        "Reception and transmission of orders in relation to one or more financial instruments",
        "Portfolio management",
        "Investment advice",
        "Investment research and financial analysis or other forms of general recommendation relating to transactions in financial instruments",
      ],
      note: "Services are provided on a cross-border basis from Luxembourg without the establishment of a branch in Italy.",
      verify: "Consult the CONSOB register",
    },
    services: {
      overline: "Investment Services",
      title: "Four authorisations. One standard of care.",
      items: [
        { title: "Order Reception & Transmission", body: "Orders in relation to one or more financial instruments received and routed with institutional discipline." },
        { title: "Execution on Behalf of Clients", body: "Best-execution obligations under MiFID II across all supported asset classes." },
        { title: "Portfolio Management", body: "Discretionary mandates managed to client-specific objectives and risk parameters." },
        { title: "Investment Advice", body: "Research-backed, personal recommendations grounded in financial analysis." },
      ],
      foTitle: "Authorised Family Office",
      foBody: "Beyond brokerage, Asteo is an authorised Family Office — actively performing since 2014. Multi-generational wealth structuring, consolidated reporting and investment oversight from a single Luxembourg counterparty.",
      foTag: "Actively performing since 20/10/2014",
    },
    heritage: {
      overline: "Luxembourg Heritage",
      title: "Boulevard de la Pétrusse. The address speaks first.",
      body: "From the financial heart of Luxembourg City, Asteo has served European investors for over a decade — combining the discretion of a family office with the infrastructure of a modern brokerage.",
      officeLabel: "Registered Office",
      officeLine1: "120 Boulevard de la Pétrusse",
      officeLine2: "L-2330 Luxembourg",
      timeline: [
        { year: "2011", text: "ASTEO LUXEMBOURG S.A. registered — 19 September 2011." },
        { year: "2014", text: "CSSF authorisation granted from the firm's historic headquarters at 25B Boulevard Royal, L-2449 Luxembourg — investment services, FX services and Family Office status, 20 October 2014." },
        { year: "Today", text: "Active Class 3 investment firm at 120 Boulevard de la Pétrusse, operating in Luxembourg and Italy." },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Speak with Luxembourg",
      lead: "No forms. Direct lines to the desk that matters.",
      addressTitle: "Registered Office",
      address: "ASTEO LUXEMBOURG S.A.\n120 Boulevard de la Pétrusse\nL-2330 Luxembourg\nGrand Duchy of Luxembourg",
      clientTitle: "Client Area",
      clientNote: "Existing clients sign in and new clients complete their application through our secure client area.",
      clientCta: "Open client area",
      deptsTitle: "Direct department contacts",
      depts: [
        { name: "General enquiries", email: "info@asteo.eu" },
        { name: "Client support", email: "support@asteo.eu" },
        { name: "Account registration", email: "registration@asteo.eu" },
        { name: "Compliance", email: "compliance@asteo.eu" },
        { name: "Data protection officer", email: "dpo@asteo.eu" },
        { name: "Complaints", email: "complaints@asteo.eu" },
        { name: "Finance", email: "finance@asteo.eu" },
      ],
      lei: "LEI 222100L7BX1XCBJHH958",
      leiNote: "Verify our legal entity identifier on GLEIF",
    },
    footer: {
      risk: "Risk Warning: CFDs are complex instruments and come with a high risk of losing money rapidly due to leverage. The majority of retail investor accounts lose money when trading CFDs. You should consider whether you understand how CFDs work and whether you can afford to take the high risk of losing your money.",
      reg: "ASTEO LUXEMBOURG S.A. is an investment firm authorised and regulated by the Commission de Surveillance du Secteur Financier (CSSF), Luxembourg — Firm N° P00000438 — and operates in Italy. IFR Class 3 (SNI investment firm). LEI 222100L7BX1XCBJHH958.",
      rights: "All rights reserved.",
      siteTitle: "Site",
      legalTitle: "Legal",
      links: { markets: "Markets", regulation: "Regulation", italy: "Italy", services: "Services", contact: "Contact" },
    },
  },
  FR: {
    nav: { markets: "Marchés", regulation: "Régulation", italy: "Italie", services: "Services", heritage: "Héritage", contact: "Contact", portal: "Espace Client" },
    hero: {
      badge: "Agréée CSSF · N° P00000438",
      lines: ["La précision", "institutionnelle", "du trading CFD."],
      lead: "ASTEO LUXEMBOURG S.A. — entreprise d'investissement européenne régulée au Luxembourg et en Italie, exécutant des stratégies multi-actifs depuis le 120 Boulevard de la Pétrusse depuis 2014.",
      cta1: "Explorer les marchés",
      cta2: "Détails réglementaires",
      stats: [
        { value: "2014", label: "Agrément CSSF" },
        { value: "Classe 3", label: "Classification IFR" },
        { value: "4", label: "Services d'investissement" },
        { value: "LU · IT", label: "Juridictions régulées" },
      ],
    },
    marquee: ["Forex", "Indices", "Matières premières", "Actions", "Régulée CSSF", "MiFID II", "Family Office", "Gestion de portefeuille", "Conseil en investissement", "LEI 222100L7BX1XCBJHH958"],
    manifesto: {
      overline: "Le Standard Asteo",
      title: "Un courtage fondé sur quatre principes",
      chapters: [
        { num: "01", title: "Précision institutionnelle", body: "Chaque ordre — réception, transmission, exécution — est traité avec la discipline d'un desk institutionnel. Agréée pour l'exécution d'ordres pour le compte de clients depuis le 20 octobre 2014." },
        { num: "02", title: "Garanties européennes", body: "Supervisée par la CSSF au Luxembourg et opérant en Italie sous passeport européen. Classification IFR Classe 3, LEI vérifié, conforme MiFID II. Votre contrepartie est une S.A. régulée." },
        { num: "03", title: "Exécution multi-actifs", body: "CFD sur devises, indices mondiaux, matières premières et actions — avec des services de change agréés liés à la fourniture de services d'investissement." },
        { num: "04", title: "Héritage Family Office", body: "Un Family Office agréé en activité depuis 2014. Gestion discrétionnaire et conseil en investissement, avec la rigueur de la banque privée luxembourgeoise." },
      ],
    },
    markets: {
      overline: "Marchés",
      title: "Tradez les marchés mondiaux, un seul compte",
      lead: "Des contrats sur différence sur quatre classes d'actifs, exécutés avec une discipline institutionnelle. Disponibilité et conditions fournies sur la plateforme de trading.",
      tabs: { forex: "Forex", indices: "Indices", commodities: "Matières premières", shares: "Actions" },
      colInstrument: "Instrument",
      colSession: "Session de trading",
      colType: "Catégorie",
      note: "Les instruments présentés sont illustratifs. Les CFD sont des instruments complexes — consultez la plateforme pour les conditions en vigueur.",
      data: {
        forex: [
          ["EUR / USD", "24h · Lun–Ven", "Majeure"],
          ["GBP / USD", "24h · Lun–Ven", "Majeure"],
          ["USD / JPY", "24h · Lun–Ven", "Majeure"],
          ["EUR / CHF", "24h · Lun–Ven", "Croisée"],
          ["USD / CAD", "24h · Lun–Ven", "Majeure"],
        ],
        indices: [
          ["EU Stocks 50", "08:00–22:00 CET", "Europe"],
          ["Allemagne 40", "08:00–22:00 CET", "Europe"],
          ["US 500", "15:30–22:00 CET", "Amérique du Nord"],
          ["US Tech 100", "15:30–22:00 CET", "Amérique du Nord"],
          ["Japon 225", "01:00–07:00 CET", "Asie"],
        ],
        commodities: [
          ["Or (XAU/USD)", "24h · Lun–Ven", "Métal précieux"],
          ["Argent (XAG/USD)", "24h · Lun–Ven", "Métal précieux"],
          ["Pétrole Brent", "03:00–23:00 CET", "Énergie"],
          ["Pétrole WTI", "03:00–23:00 CET", "Énergie"],
          ["Gaz naturel", "03:00–23:00 CET", "Énergie"],
        ],
        shares: [
          ["Blue chips européennes", "09:00–17:30 CET", "CFD Actions"],
          ["Grandes capitalisations US", "15:30–22:00 CET", "CFD Actions"],
          ["Actions cotées italiennes", "09:00–17:30 CET", "CFD Actions"],
          ["Cotées au Luxembourg", "09:00–17:30 CET", "CFD Actions"],
          ["Constituants du FTSE UK", "09:00–17:30 CET", "CFD Actions"],
        ],
      },
    },
    regulation: {
      overline: "Régulation & Agrément",
      title: "Pleinement agréée. Pleinement transparente.",
      lead: "ASTEO LUXEMBOURG S.A. est une entreprise d'investissement supervisée par la Commission de Surveillance du Secteur Financier (CSSF), Luxembourg, et opère en Italie.",
      cardTitle: "Registre public CSSF",
      fields: [
        ["Nom", "ASTEO LUXEMBOURG S.A. (Active)"],
        ["Type", "Entreprise d'investissement"],
        ["N° d'agrément", "P00000438"],
        ["Siège social", "120 Boulevard de la Pétrusse, L-2330 Luxembourg"],
        ["Date de validité", "20/10/2014"],
        ["Code LEI", "222100L7BX1XCBJHH958"],
        ["Classification IFR", "Classe 3 (entreprise d'investissement SNI)"],
      ],
      servicesTitle: "Services et activités d'investissement",
      auxTitle: "Services auxiliaires",
      statusTitle: "Autres statuts",
      colService: "Autorisation",
      colStart: "Début de validité",
      colEnd: "Fin de validité",
      ongoing: "En cours",
      services: [
        "1 — Réception et transmission d'ordres portant sur un ou plusieurs instruments financiers",
        "2 — Exécution d'ordres pour le compte de clients",
        "4 — Gestion de portefeuille",
        "5 — Conseil en investissement",
      ],
      aux: [
        "4 — Services de change liés à la fourniture de services d'investissement",
        "5 — Recherche en investissements et analyse financière ou toute autre forme de recommandation générale",
      ],
      status: ["Family Office", "Family Office agréé exerçant activement l'activité de Family Office"],
      history: "Historique du nom : enregistrée sous ASTEO LUXEMBOURG S.A. depuis le 19/09/2011.",
      verify: "Vérifier sur le registre CSSF",
    },
    italy: {
      overline: "Italie · Registre CONSOB",
      title: "Autorisée à opérer en Italie",
      lead: "Au titre de la libre prestation de services MiFID II, ASTEO LUXEMBOURG S.A. est inscrite à l'elenco des entreprises d'investissement de l'UE opérant en Italie sans succursale, tenu par la CONSOB.",
      cardTitle: "Inscription au registre — Italie",
      fields: [
        ["Entreprise d'investissement", "ASTEO LUXEMBOURG S.A."],
        ["Siège social", "120 Boulevard de la Pétrusse"],
        ["Ville", "L-2330 Luxembourg"],
        ["État", "Luxembourg"],
        ["N° d'inscription", "4129"],
      ],
      servicesTitle: "Services exerçables en Italie",
      services: [
        "Réception et transmission d'ordres portant sur un ou plusieurs instruments financiers",
        "Gestion de portefeuille",
        "Conseil en investissement",
        "Recherche en investissements et analyse financière ou toute autre forme de recommandation générale concernant les opérations sur instruments financiers",
      ],
      note: "Les services sont fournis de manière transfrontalière depuis le Luxembourg, sans établissement d'une succursale en Italie.",
      verify: "Consulter le registre CONSOB",
    },
    services: {
      overline: "Services d'investissement",
      title: "Quatre agréments. Un seul standard d'exigence.",
      items: [
        { title: "Réception & transmission d'ordres", body: "Ordres portant sur un ou plusieurs instruments financiers reçus et acheminés avec une discipline institutionnelle." },
        { title: "Exécution pour le compte de clients", body: "Obligations de meilleure exécution sous MiFID II sur toutes les classes d'actifs prises en charge." },
        { title: "Gestion de portefeuille", body: "Mandats discrétionnaires gérés selon les objectifs et paramètres de risque de chaque client." },
        { title: "Conseil en investissement", body: "Recommandations personnelles fondées sur la recherche et l'analyse financière." },
      ],
      foTitle: "Family Office agréé",
      foBody: "Au-delà du courtage, Asteo est un Family Office agréé — en activité depuis 2014. Structuration patrimoniale multigénérationnelle, reporting consolidé et supervision des investissements depuis une seule contrepartie luxembourgeoise.",
      foTag: "En activité depuis le 20/10/2014",
    },
    heritage: {
      overline: "Héritage luxembourgeois",
      title: "Boulevard de la Pétrusse. L'adresse parle d'elle-même.",
      body: "Depuis le cœur financier de Luxembourg-Ville, Asteo sert les investisseurs européens depuis plus d'une décennie — alliant la discrétion d'un family office à l'infrastructure d'un courtage moderne.",
      officeLabel: "Siège social",
      officeLine1: "120 Boulevard de la Pétrusse",
      officeLine2: "L-2330 Luxembourg",
      timeline: [
        { year: "2011", text: "ASTEO LUXEMBOURG S.A. enregistrée — 19 septembre 2011." },
        { year: "2014", text: "Agrément CSSF accordé depuis le siège historique du 25B Boulevard Royal, L-2449 Luxembourg — services d'investissement, services de change et statut de Family Office, 20 octobre 2014." },
        { year: "Aujourd'hui", text: "Entreprise d'investissement Classe 3 active au 120 Boulevard de la Pétrusse, opérant au Luxembourg et en Italie." },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Parlez avec Luxembourg",
      lead: "Pas de formulaires. Des lignes directes vers le bon interlocuteur.",
      addressTitle: "Siège social",
      address: "ASTEO LUXEMBOURG S.A.\n120 Boulevard de la Pétrusse\nL-2330 Luxembourg\nGrand-Duché de Luxembourg",
      clientTitle: "Espace client",
      clientNote: "Les clients existants se connectent et les nouveaux clients complètent leur dossier via notre espace client sécurisé.",
      clientCta: "Ouvrir l'espace client",
      deptsTitle: "Contacts directs par service",
      depts: [
        { name: "Renseignements généraux", email: "info@asteo.eu" },
        { name: "Support client", email: "support@asteo.eu" },
        { name: "Ouverture de compte", email: "registration@asteo.eu" },
        { name: "Conformité", email: "compliance@asteo.eu" },
        { name: "Délégué à la protection des données", email: "dpo@asteo.eu" },
        { name: "Réclamations", email: "complaints@asteo.eu" },
        { name: "Finance", email: "finance@asteo.eu" },
      ],
      lei: "LEI 222100L7BX1XCBJHH958",
      leiNote: "Vérifiez notre identifiant d'entité juridique sur GLEIF",
    },
    footer: {
      risk: "Avertissement sur les risques : les CFD sont des instruments complexes et présentent un risque élevé de perte rapide en capital en raison de l'effet de levier. La majorité des comptes d'investisseurs particuliers perdent de l'argent en négociant des CFD. Vous devez vous assurer que vous comprenez le fonctionnement des CFD et que vous pouvez vous permettre de prendre le risque élevé de perdre votre argent.",
      reg: "ASTEO LUXEMBOURG S.A. est une entreprise d'investissement agréée et régulée par la Commission de Surveillance du Secteur Financier (CSSF), Luxembourg — N° P00000438 — et opère en Italie. IFR Classe 3 (entreprise d'investissement SNI). LEI 222100L7BX1XCBJHH958.",
      rights: "Tous droits réservés.",
      siteTitle: "Site",
      legalTitle: "Juridique",
      links: { markets: "Marchés", regulation: "Régulation", italy: "Italie", services: "Services", contact: "Contact" },
    },
  },
  IT: {
    nav: { markets: "Mercati", regulation: "Regolamentazione", italy: "Italia", services: "Servizi", heritage: "Storia", contact: "Contatti", portal: "Area Clienti" },
    hero: {
      badge: "Regolamentata CSSF · N° P00000438",
      lines: ["Precisione", "istituzionale nel", "trading di CFD."],
      lead: "ASTEO LUXEMBOURG S.A. — impresa di investimento europea regolamentata in Lussemburgo e in Italia, che esegue strategie multi-asset dal 120 Boulevard de la Pétrusse dal 2014.",
      cta1: "Esplora i mercati",
      cta2: "Dettagli normativi",
      stats: [
        { value: "2014", label: "Autorizzazione CSSF" },
        { value: "Classe 3", label: "Classificazione IFR" },
        { value: "4", label: "Servizi di investimento" },
        { value: "LU · IT", label: "Giurisdizioni regolamentate" },
      ],
    },
    marquee: ["Forex", "Indici", "Materie prime", "Azioni", "Regolamentata CSSF", "MiFID II", "Family Office", "Gestione di portafogli", "Consulenza in materia di investimenti", "LEI 222100L7BX1XCBJHH958"],
    manifesto: {
      overline: "Lo Standard Asteo",
      title: "Un brokeraggio fondato su quattro principi",
      chapters: [
        { num: "01", title: "Precisione istituzionale", body: "Ogni ordine — ricezione, trasmissione, esecuzione — è gestito con la disciplina di un desk istituzionale. Autorizzata all'esecuzione di ordini per conto dei clienti dal 20 ottobre 2014." },
        { num: "02", title: "Tutele europee", body: "Vigilata dalla CSSF in Lussemburgo e operante in Italia con passaporto europeo. Classificazione IFR Classe 3, LEI verificato, conforme a MiFID II. La vostra controparte è una S.A. regolamentata." },
        { num: "03", title: "Esecuzione multi-asset", body: "CFD su valute, indici globali, materie prime e azioni — con servizi di cambio autorizzati collegati alla prestazione di servizi di investimento." },
        { num: "04", title: "Tradizione Family Office", body: "Un Family Office autorizzato e attivo dal 2014. Gestione discrezionale di portafogli e consulenza, con il rigore del private banking lussemburghese." },
      ],
    },
    markets: {
      overline: "Mercati",
      title: "Opera sui mercati mondiali, con un solo conto",
      lead: "Contratti per differenza su quattro classi di attività, eseguiti con disciplina istituzionale. Disponibilità e condizioni fornite sulla piattaforma di trading.",
      tabs: { forex: "Forex", indices: "Indici", commodities: "Materie prime", shares: "Azioni" },
      colInstrument: "Strumento",
      colSession: "Sessione di negoziazione",
      colType: "Categoria",
      note: "Gli strumenti mostrati sono illustrativi. I CFD sono strumenti complessi — consultare la piattaforma per le condizioni in vigore.",
      data: {
        forex: [
          ["EUR / USD", "24h · Lun–Ven", "Principale"],
          ["GBP / USD", "24h · Lun–Ven", "Principale"],
          ["USD / JPY", "24h · Lun–Ven", "Principale"],
          ["EUR / CHF", "24h · Lun–Ven", "Cross"],
          ["USD / CAD", "24h · Lun–Ven", "Principale"],
        ],
        indices: [
          ["EU Stocks 50", "08:00–22:00 CET", "Europa"],
          ["Germania 40", "08:00–22:00 CET", "Europa"],
          ["US 500", "15:30–22:00 CET", "Nord America"],
          ["US Tech 100", "15:30–22:00 CET", "Nord America"],
          ["Giappone 225", "01:00–07:00 CET", "Asia"],
        ],
        commodities: [
          ["Oro (XAU/USD)", "24h · Lun–Ven", "Metallo prezioso"],
          ["Argento (XAG/USD)", "24h · Lun–Ven", "Metallo prezioso"],
          ["Petrolio Brent", "03:00–23:00 CET", "Energia"],
          ["Petrolio WTI", "03:00–23:00 CET", "Energia"],
          ["Gas naturale", "03:00–23:00 CET", "Energia"],
        ],
        shares: [
          ["Blue chip europee", "09:00–17:30 CET", "CFD Azioni"],
          ["Large cap USA", "15:30–22:00 CET", "CFD Azioni"],
          ["Azioni quotate italiane", "09:00–17:30 CET", "CFD Azioni"],
          ["Quotate in Lussemburgo", "09:00–17:30 CET", "CFD Azioni"],
          ["Componenti FTSE UK", "09:00–17:30 CET", "CFD Azioni"],
        ],
      },
    },
    regulation: {
      overline: "Regolamentazione e Licenze",
      title: "Pienamente autorizzata. Pienamente trasparente.",
      lead: "ASTEO LUXEMBOURG S.A. è un'impresa di investimento vigilata dalla Commission de Surveillance du Secteur Financier (CSSF), Lussemburgo, e opera in Italia.",
      cardTitle: "Registro pubblico CSSF",
      fields: [
        ["Denominazione", "ASTEO LUXEMBOURG S.A. (Attiva)"],
        ["Tipo", "Impresa di investimento"],
        ["N° di licenza", "P00000438"],
        ["Sede legale", "120 Boulevard de la Pétrusse, L-2330 Lussemburgo"],
        ["Data di validità", "20/10/2014"],
        ["Codice LEI", "222100L7BX1XCBJHH958"],
        ["Classificazione IFR", "Classe 3 (impresa di investimento SNI)"],
      ],
      servicesTitle: "Servizi e attività di investimento",
      auxTitle: "Servizi accessori",
      statusTitle: "Altri status",
      colService: "Autorizzazione",
      colStart: "Inizio validità",
      colEnd: "Fine validità",
      ongoing: "In corso",
      services: [
        "1 — Ricezione e trasmissione di ordini riguardanti uno o più strumenti finanziari",
        "2 — Esecuzione di ordini per conto dei clienti",
        "4 — Gestione di portafogli",
        "5 — Consulenza in materia di investimenti",
      ],
      aux: [
        "4 — Servizi di cambio collegati alla prestazione di servizi di investimento",
        "5 — Ricerca in materia di investimenti e analisi finanziaria o altre forme di raccomandazione generale",
      ],
      status: ["Family Office", "Family Office autorizzato che svolge attivamente l'attività di Family Office"],
      history: "Storico della denominazione: registrata come ASTEO LUXEMBOURG S.A. dal 19/09/2011.",
      verify: "Verifica sul registro CSSF",
    },
    italy: {
      overline: "Italia · Elenco CONSOB",
      title: "Autorizzata a operare in Italia",
      lead: "In regime di libera prestazione di servizi MiFID II, ASTEO LUXEMBOURG S.A. è iscritta nell'elenco delle imprese di investimento UE che operano in Italia senza stabilimento di succursali, tenuto dalla CONSOB.",
      cardTitle: "Iscrizione all'elenco — Italia",
      fields: [
        ["Impresa di investimento", "ASTEO LUXEMBOURG S.A."],
        ["Sede legale", "120 Boulevard de la Pétrusse"],
        ["Città", "L-2330 Lussemburgo"],
        ["Stato", "Lussemburgo"],
        ["N. iscrizione all'elenco", "4129"],
      ],
      servicesTitle: "Servizi esercitabili in Italia",
      services: [
        "Ricezione e trasmissione di ordini riguardanti uno o più strumenti finanziari",
        "Gestione di portafogli",
        "Consulenza in materia di investimenti",
        "Ricerca in materia di investimenti e analisi finanziaria o altre forme di raccomandazione generale riguardanti le operazioni relative a strumenti finanziari",
      ],
      note: "I servizi sono prestati in regime transfrontaliero dal Lussemburgo, senza stabilimento di succursali in Italia.",
      verify: "Consulta l'elenco CONSOB",
    },
    services: {
      overline: "Servizi di investimento",
      title: "Quattro autorizzazioni. Un unico standard di cura.",
      items: [
        { title: "Ricezione e trasmissione di ordini", body: "Ordini riguardanti uno o più strumenti finanziari ricevuti e instradati con disciplina istituzionale." },
        { title: "Esecuzione per conto dei clienti", body: "Obblighi di best execution ai sensi di MiFID II su tutte le classi di attività supportate." },
        { title: "Gestione di portafogli", body: "Mandati discrezionali gestiti secondo gli obiettivi e i parametri di rischio di ciascun cliente." },
        { title: "Consulenza in materia di investimenti", body: "Raccomandazioni personalizzate fondate su ricerca e analisi finanziaria." },
      ],
      foTitle: "Family Office autorizzato",
      foBody: "Oltre al brokeraggio, Asteo è un Family Office autorizzato — attivo dal 2014. Strutturazione patrimoniale multigenerazionale, reporting consolidato e supervisione degli investimenti da un'unica controparte lussemburghese.",
      foTag: "Attivo dal 20/10/2014",
    },
    heritage: {
      overline: "Tradizione lussemburghese",
      title: "Boulevard de la Pétrusse. L'indirizzo parla da sé.",
      body: "Dal cuore finanziario di Lussemburgo, Asteo serve gli investitori europei da oltre un decennio — unendo la discrezione di un family office all'infrastruttura di un brokeraggio moderno.",
      officeLabel: "Sede legale",
      officeLine1: "120 Boulevard de la Pétrusse",
      officeLine2: "L-2330 Lussemburgo",
      timeline: [
        { year: "2011", text: "ASTEO LUXEMBOURG S.A. registrata — 19 settembre 2011." },
        { year: "2014", text: "Autorizzazione CSSF concessa dalla storica sede di 25B Boulevard Royal, L-2449 Lussemburgo — servizi di investimento, servizi di cambio e status di Family Office, 20 ottobre 2014." },
        { year: "Oggi", text: "Impresa di investimento Classe 3 attiva in 120 Boulevard de la Pétrusse, operante in Lussemburgo e in Italia." },
      ],
    },
    contact: {
      overline: "Contatti",
      title: "Parla con il Lussemburgo",
      lead: "Nessun modulo. Linee dirette con il desk giusto.",
      addressTitle: "Sede legale",
      address: "ASTEO LUXEMBOURG S.A.\n120 Boulevard de la Pétrusse\nL-2330 Lussemburgo\nGranducato di Lussemburgo",
      clientTitle: "Area clienti",
      clientNote: "I clienti esistenti accedono e i nuovi clienti completano la richiesta di apertura tramite la nostra area clienti sicura.",
      clientCta: "Apri l'area clienti",
      deptsTitle: "Contatti diretti per funzione",
      depts: [
        { name: "Informazioni generali", email: "info@asteo.eu" },
        { name: "Assistenza clienti", email: "support@asteo.eu" },
        { name: "Apertura conto", email: "registration@asteo.eu" },
        { name: "Compliance", email: "compliance@asteo.eu" },
        { name: "Responsabile protezione dati", email: "dpo@asteo.eu" },
        { name: "Reclami", email: "complaints@asteo.eu" },
        { name: "Finanza", email: "finance@asteo.eu" },
      ],
      lei: "LEI 222100L7BX1XCBJHH958",
      leiNote: "Verifica il nostro identificativo LEI su GLEIF",
    },
    footer: {
      risk: "Avvertenza sui rischi: i CFD sono strumenti complessi e presentano un rischio elevato di perdere denaro rapidamente a causa della leva finanziaria. La maggior parte dei conti degli investitori al dettaglio perde denaro negoziando CFD. Valuti se comprende il funzionamento dei CFD e se può permettersi di correre l'elevato rischio di perdere il proprio denaro.",
      reg: "ASTEO LUXEMBOURG S.A. è un'impresa di investimento autorizzata e regolamentata dalla Commission de Surveillance du Secteur Financier (CSSF), Lussemburgo — N° P00000438 — e opera in Italia. IFR Classe 3 (impresa di investimento SNI). LEI 222100L7BX1XCBJHH958.",
      rights: "Tutti i diritti riservati.",
      siteTitle: "Sito",
      legalTitle: "Legale",
      links: { markets: "Mercati", regulation: "Regolamentazione", italy: "Italia", services: "Servizi", contact: "Contatti" },
    },
  },
};
